import { jsx } from 'react/jsx-runtime';
import { Label as Label$1 } from '../../vendor/@radix-ui/react-label/dist/index.mjs';
import { cva } from '../../vendor/class-variance-authority/dist/index.mjs';
import * as React from 'react';
import { cn } from '../../lib/utils.js';

const labelVariants = cva(
  "text-sm font-weight-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);
const Label = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(Label$1, { ref, className: cn(labelVariants(), className), ...props }));
Label.displayName = Label$1.displayName;

export { Label };
